import { Action } from '@ngrx/store';
import { DashboardSelection } from '../models/dashboard-selection.model';
import { type } from '../util';

/**
 * Actions for adding and removing a dashboard selection.
 */

export const ACTION_TYPES = {
  SET_SELECTION: type<'[DashboardSelection] Set Dashboard Selection'>('[DashboardSelection] Set Dashboard Selection'),
};

export class SetSelectionAction implements Action {
  public readonly type = ACTION_TYPES.SET_SELECTION;
  constructor(public readonly payload: DashboardSelection) {}
}
export type Actions = SetSelectionAction;
